import * as stylex from "@stylexjs/stylex";

import { colors } from "../../../styles/tokens.stylex";

export interface ICategoryLink {
    active: boolean;
    text: string;
    onClick?: () => void;
}

const styles = stylex.create({
    button: {
        borderColor: colors.fg_Accent,
        borderStyle: "solid",

        borderWidth: "1px",
        color: colors.fg_Accent,
        fontSize: "0.75rem",
        fontWeight: 400,

        lineHeight: 1.2,
        paddingBlock: "6px",
        paddingInline: "10px",
        textWrap: "nowrap",
        transition: "all 200ms ease-in-out",
    },
    active: {
        backgroundColor: colors.fg_Accent,
        color: colors.b_Emphasis,
    },
});

export const CategoryLink = (props: ICategoryLink) =>
    (props.text && (
        <button
            {...stylex.props(styles.button, props.active && styles.active)}
            onClick={props.onClick}
            type="button"
        >
            {props.text}
        </button>
    )) ||
    null;
